import * as Icons from '@spotnana/pixel-react/dist/Icons';
import theme from '@spotnana/pixel-react/dist/utils/themes/theme';
import { BannerContainer, BannerText } from './styles';

interface IProps {
  value: string;
}

const Banner = ({ value }: IProps) => {
  return (
    <BannerContainer>
      <Icons.FareIncrease height={10} width={16} primaryColor={theme.colors.bg.lightYellowInfo} />
      <BannerText>{value}</BannerText>
    </BannerContainer>
  );
};

export default Banner;
